import PropTypes from "prop-types"
import { usePageAssets } from "hooks/usePageAssets"
import Heading from "components/ui/Heading"
import DecoratedSection from "components/ui/Layout/DecoratedSection"
import SplitContainer from "components/ui/Layout/SplitContainer"

function InteractiveAnalyticsAnywhereSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset(
    "internal-tooling-interactive-analytics-anywhere"
  )
  return (
    <DecoratedSection className={className}>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="max-w-2xl mx-auto"
      >
        <Heading
          label="Interactive Analytics Anywhere"
          title="Create integrated workflows"
          subtitle={
            <>
              Give everyone in your organization access to their data without
              taking them out of their daily workflows. Preset makes it possible
              to embed an entire dashboard or a single chart in a home-grown
              application with full brand and visual control.
            </>
          }
          narrow
        />
      </SplitContainer>
    </DecoratedSection>
  )
}

InteractiveAnalyticsAnywhereSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default InteractiveAnalyticsAnywhereSection
